import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-master-crud',
  templateUrl: './master-crud.component.html',
  styleUrls: ['./master-crud.component.scss']
})
export class MasterCrudComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public CurrentDetail:any=[];
  public CurrentUrl:any=this.router.url;
  public statusCheck : any = 1 ;


  masterData = new FormGroup({
    name:new FormControl('',Validators.compose([
      Validators.required ])), 
    // description:new FormControl(''),
    // status:new FormControl('',Validators.compose([
    //   Validators.required ])),
  })
  
   get f() { return this.masterData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {
    if(this.CurrentUrl == '/update-interest' || this.CurrentUrl=='/update-hair-type' || this.CurrentUrl=='/update-eye-type' || this.CurrentUrl=='/update-body-type' || this.CurrentUrl=='/update-prefrence' || this.CurrentUrl=='/update-langugae' ){ 
      this.CurrentDetail= JSON.parse(localStorage.getItem('hva_content')||'{}')
      if(this.CurrentUrl == '/update-interest'){
        this.imgURL= this.CurrentDetail.icon;
        this.statusCheck =this.CurrentDetail.status;
      } else if(this.CurrentUrl == '/update-hair-type'){
        this.CurrentDetail.name=this.CurrentDetail.hairType;
        this.statusCheck =this.CurrentDetail.status;
      } else if(this.CurrentUrl == '/update-eye-type'){
        this.CurrentDetail.name=this.CurrentDetail.eyeType;
        this.statusCheck =this.CurrentDetail.status;
      } else if(this.CurrentUrl == '/update-body-type'){
        this.CurrentDetail.name=this.CurrentDetail.bodyType;
        this.statusCheck =this.CurrentDetail.status;
      } else if(this.CurrentUrl == '/update-prefrence'){
        this.CurrentDetail.name=this.CurrentDetail.preference;
        this.statusCheck =this.CurrentDetail.status;
      } else if(this.CurrentUrl == '/update-langugae'){
        this.CurrentDetail.name=this.CurrentDetail.language;
        this.statusCheck =this.CurrentDetail.status;
      }  
      setTimeout(()=>{
        this.service.wordCounter();    
      },1000)
      
    }
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail:any = this.masterData;      
       var url:any='';
       var detail:any={};
       let formdata= new FormData();
      //  if(this.CurrentUrl == '/update-prefer' || this.CurrentUrl == '/add-social-tendancies'){
       if(this.imgURL == ''){
         this.service.dangerAlert('Please upload the image');
         return
       } else {
         if(this.selectedFile!=''){
            if( this.CurrentUrl =='/add-interest' || this.CurrentUrl =='/update-interest'){
              formdata.append('icon',this.selectedFile);
            }
       }
       }
       if(userdetail.valid){  
        this.loading=true;     
        formdata.append("name", userdetail.value.name);         
         if(this.CurrentUrl == '/update-interest' ){
            url="master/update-interest/"+this.CurrentDetail._id;
            // formdata.append("status", this.statusCheck);
          this.service.updateFormData1(formdata,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.masterData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        } else { 
            url='master/add-interest';
            // formdata.append("status", userdetail.value.status);
          this.service.PostApiFormData(formdata,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.masterData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        }
       }
  // }     
    
  }

  Onsubmit1(){
    this.submitted = true;    
      let userdetail = this.masterData;
      if(userdetail.valid){
        this.loading=true;
        var url="";
        var detail:any={};
        if(this.CurrentUrl=='/add-hair-type'||this.CurrentUrl=='/add-eye-type'|| this.CurrentUrl=='/add-body-type'|| this.CurrentUrl=='/add-prefrence'||this.CurrentUrl=='/add-langugae'){
         if(this.CurrentUrl == '/add-hair-type'){
          url="master/add-hair-type";
          detail.hairType=userdetail.value.name;
        } else if(this.CurrentUrl == '/add-eye-type'){
          url="master/add-eye-type";
          detail.eyeType=userdetail.value.name;
        } else if(this.CurrentUrl == '/add-body-type'){
          url="master/add-body-type";
          detail.bodyType=userdetail.value.name;
        } else if(this.CurrentUrl == '/add-prefrence'){
          url="master/add-preference";
          detail.preference=userdetail.value.name;
        } else if(this.CurrentUrl == '/add-langugae'){
          url="master/add-language";
          detail.language=userdetail.value.name;
        }
        // detail.status=this.statusCheck;
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.masterData.reset();
              this.submitted = false;  
              this.loading=false; 
              this.service.back(); 
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        } 
        if(this.CurrentUrl=='/update-hair-type' || this.CurrentUrl=='/update-eye-type' || this.CurrentUrl=='/update-body-type' || this.CurrentUrl=='/update-prefrence' || this.CurrentUrl=='/update-langugae'){
          if(this.CurrentUrl == '/update-hair-type'){
            url="master/update-hair-type/"+this.CurrentDetail._id;;
            detail.hairType=userdetail.value.name;
          } else if(this.CurrentUrl == '/update-eye-type'){
            url="master/update-eye-type/"+this.CurrentDetail._id;;
            detail.eyeType=userdetail.value.name;
          } else if(this.CurrentUrl == '/update-body-type'){
            url="master/update-body-type/"+this.CurrentDetail._id;;
            detail.bodyType=userdetail.value.name;
          } else if(this.CurrentUrl == '/update-prefrence'){
            url="master/update-preference/"+this.CurrentDetail._id;;
            detail.preference=userdetail.value.name;
          } else if(this.CurrentUrl == '/update-langugae'){
            url="master/update-language/"+this.CurrentDetail._id;;
            detail.language=userdetail.value.name;
          }
          // detail.status=this.statusCheck;
          this.service.updateApi1(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.masterData.reset();
              this.submitted = false;  
              this.loading=false; 
              this.service.back(); 
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        }
       
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
  

  getUploadFileDetail(event: any) {
    var self=this;
    //this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.service.dangerAlert("Only images are supported.");
        return;
      }
   
      // const img:any = document.createElement('file1');
      // img.onload = (e:any) => {
      //   console.log(e.result);
      //   const width = e.path[0].width;
      //   const height = e.path[0].height;
      
      // }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event:any) => {
        if(self.CurrentUrl=='/add-community' || self.CurrentUrl=='/update-community'){
          var img :any= new Image();      
          img.src = _event.target.result;
          img.onload = function () {
            var w = this.width;
            var h = this.height;
            if (w > h) {
              self.imgURL = reader.result;
            } else {
              console.log('w:' + w);
              console.log('h:' + h);
              self.service.dangerAlert('Please upload a landscape image');
              self.selectedFile = ''; // Clear the input
              return;
            }
          }
        } else {
          this.imgURL = reader.result;
        }
      };
    }
  }
  
  changeImage() {
    $("#file1").trigger("click");
  }

  getCheckType(event:any){
    if(event.target.checked){
      this.statusCheck = 1;
    } else {
      this.statusCheck = 0;
    }    
  }

}
